export enum DashboardPage {
    Dashboard,
    Users
}